// src/components/access/RequireFeature.tsx
import { useFeatureStore } from '@/stores/featureStore';
import type { FeatureKey } from '@/lib/features/featureFlags';

export function RequireFeature({ feature, children, fallback }: {
  feature: FeatureKey;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const { featureFlags } = useFeatureStore();

  if (!featureFlags) return null; // not loaded yet
  if (!featureFlags[feature]) return fallback ? <>{fallback}</> : null;

  return <>{children}</>;
}
